import { Route, Routes } from 'react-router-dom';


import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';

import { createContext, useEffect, useState } from 'react';
import { RefreshContext } from './components/privateRoute/RefreshContext';
import NavBar from './components/Navigation/navBar';
import PrivateRoute from './components/privateRoute/privateRoute';
import LoginProfilePage from './Authentication/LoginProfilePage';
import ProfilePage from './Authentication/Profile';
import RegisterPage from './Authentication/RegisterPage';
import InventoryTable from './components/Restock/RequestRestock';
import UsersTable from './Authentication/UserList';
import RestockRequests from './components/Restock/ReceivedRestockRequest';
import RestockList from './components/Restock/restockList';




const theme = createTheme({
	palette: {
		mode: 'light', // Light theme
		// You can customize the theme colors as needed
	},
});

// Define the shape of the context


// Initialize the UserContext with default values
export const UserContext = createContext<any>({});

function App() {

	const [refresh, setRefresh] = useState(false);
	const [authenticatedUser, setAuthenticatedUser] = useState<IUserSessionInfo>({
		_id: null,
		email: "",
		first_name: "",
		last_name: "",
		scope: "",
		location: "",
	});
	useEffect(() => {
		async function loadUserSession() {
			try {
				let fetchRes = await fetch("/auth/user", {
					method: "POST",
					credentials: "include",
				});
				let response = await fetchRes.json();
				setAuthenticatedUser((val) => response.user);
			} catch (e) {
				console.log(e);
			}
		}
		loadUserSession();
	}, []);


	return (
	
		<RefreshContext.Provider value={{ refresh, setRefresh }}>
		<UserContext.Provider value={{ authenticatedUser, setAuthenticatedUser }}>

			<ThemeProvider theme={theme}>

				<Routes>

					<Route path='/' element={<NavBar />} />
					<Route path='/reqRestock' element={<PrivateRoute page={<InventoryTable />} />} />
					<Route path="/user">
						<Route path="login" element={<LoginProfilePage />} />
						<Route path="profile" element={<PrivateRoute page={<ProfilePage />} />} />
						<Route path="register" element={<PrivateRoute page={<RegisterPage />} />} />
					</Route>
					<Route path="/userList" element={<PrivateRoute page={<UsersTable />} />} />
					<Route path="/restockList" element={<PrivateRoute page={<RestockList />} />} />
					<Route path="/restock" element={<PrivateRoute page={<RestockRequests />} />} />
				</Routes>
			</ThemeProvider>

		</UserContext.Provider>
	</RefreshContext.Provider>
		
	);
}

export default App;